<template>
  <div id="totalBox">
    <div class="bannerContent">
      <p class="bannerTitle">为青山绿水而战，为智慧出行而生，让人民群众停车不再难</p>
      <p class="bannerText">推动互联网、大数据、人工智能和实体经济深度融合，在中高端消费、创新引领、绿色低碳、共享</p>
      <p class="bannerText">经济、现代供应链、人力资本服务等领域培育新增长点、形成新动能。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Aboutbanner',
  data: function () {
    return {
      msg: '1'
    }
  }
}
</script>

<style scoped>
#totalBox{
  width: 100%;
  height: 600px;
  background-image: url(../../assets/about/bannerBack.jpg);
  background-repeat: no-repeat;
}
.bannerContent{
  width: 1200px;
  height: 600px;
  padding-top: 206px;
  margin: 0 auto;
}
.bannerTitle{
  font-size:40px;
  font-family:Microsoft YaHei;
  font-weight:bold;
  color:rgba(255,255,255,1);
  margin-bottom: 40px;
}
.bannerText{
  font-size:20px;
  font-weight:400;
  color:rgba(255,255,255,1);
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/about/banner.vue